export default [
  {
    "slug": "sam",
    "group": "sam",
    "ext": "sam",
    "name": "sam",
    "description": "Scribe Abbreviated Markup",
    "mime_type": "application/xml",
    "uploadable": true,
    "bin": false
  },
  {
    "slug": "scml",
    "group": "scml",
    "ext": "scml",
    "name": "ScML",
    "description": "Scribe Markup Language",
    "mime_type": "application/xml",
    "uploadable": true,
    "bin": false
  },
  {
    "slug": "docx",
    "group": "docx",
    "ext": "docx",
    "name": "MS Word",
    "description": "MS Word Document",
    "mime_type": "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "uploadable": true,
    "bin": true
  },
  {
    "slug": "idtt",
    "group": "idtt",
    "ext": "txt",
    "name": "IDTT",
    "description": "InDesign Tagged Text",
    "mime_type": "text/plain",
    "uploadable": false,
    "bin": false
  },
  {
    "slug": "indd",
    "group": "indd",
    "ext": "xml",
    "name": "InD XML",
    "description": "InDesign XML",
    "mime_type": "application/xml",
    "uploadable": true,
    "bin": false
  },
  {
    "slug": "epub2",
    "group": "epub",
    "ext": "epub",
    "name": "ePub v2",
    "description": "Electronic Publication V2",
    "mime_type": "application/epub+zip",
    "uploadable": false,
    "bin": true
  },
  {
    "slug": "epub3",
    "group": "epub",
    "ext": "epub",
    "name": "ePub v3",
    "description": "Electronic Publication V3",
    "mime_type": "application/epub+zip",
    "uploadable": false,
    "bin": true
  },
  {
    "slug": "mobi",
    "group": "epub",
    "ext": "mobi",
    "name": "Mobi",
    "description": "MOBI",
    "mime_type": "application/x-mobipocket-ebook",
    "uploadable": false,
    "bin": true
  },
  {
    "slug": "css",
    "group": "css",
    "ext": "css",
    "name": "CSS",
    "description": "Cascading Style Sheet",
    "mime_type": "text/css",
    "uploadable": true,
    "bin": false
  },
  {
    "slug": "html",
    "group": "html",
    "ext": "html",
    "name": "HTML",
    "description": "HyperText Markup Language",
    "mime_type": "text/html",
    "uploadable": false,
    "bin": false
  },
  {
    "slug": "png",
    "group": "image",
    "ext": "png",
    "name": "PNG",
    "description": "Portable Network Graphics",
    "mime_type": "image/png",
    "uploadable": true,
    "bin": true
  },
  {
    "slug": "svg",
    "group": "image",
    "ext": "svg",
    "name": "SVG",
    "description": "Scalable Vector Graphics",
    "mime_type": "image/svg+xml",
    "uploadable": true,
    "bin": false
  },
  {
    "slug": "tiff",
    "group": "image",
    "ext": "tiff",
    "name": "TIFF",
    "description": "Tagged Image File Format",
    "mime_type": "image/tiff",
    "uploadable": true,
    "bin": true
  },
  {
    "slug": "jpeg",
    "group": "image",
    "ext": "jpeg",
    "name": "JPG",
    "description": "JPEG Image",
    "mime_type": "image/jpeg",
    "uploadable": true,
    "bin": true
  },
  {
    "slug": "ttf",
    "group": "font",
    "ext": "ttf",
    "name": "TTF",
    "description": "True Type Font",
    "mime_type": "application/octet-stream",
    "uploadable": true,
    "bin": true
  },
  {
    "slug": "otf",
    "group": "font",
    "ext": "otf",
    "name": "OTF",
    "description": "Open Font Type",
    "mime_type": "font/opentype",
    "uploadable": true,
    "bin": true
  },
  {
    "slug": "pdf",
    "group": "pdf",
    "ext": "pdf",
    "name": "PDF",
    "description": "Portable Document Format",
    "mime_type": "application/pdf",
    "uploadable": false,
    "bin": true
  },
  {
    "slug": "sct",
    "group": "sct",
    "ext": "sct",
    "name": "ScT",
    "description": "Scribe Template",
    "mime_type": "text/yaml",
    "uploadable": true,
    "bin": false
  }
]